import {PayloadAction, createSlice} from "@reduxjs/toolkit";

const darkBackgroundUrl: string = "/images/bg_dark.png";
const lightBackgroundUrl: string = "/images/bg_light.png";

const initialState = {
    background: darkBackgroundUrl,
    theme: 'dark',
};

function getThemeUrl(type: ThemeType): string {
    const urls: Record<ThemeType, string> = {
        DARK: darkBackgroundUrl,
        LIGHT: lightBackgroundUrl,
    };
    return urls[type] ?? 'Invalid type';
}

export const ThemeType = {
    DARK: 'DARK',
    LIGHT: 'LIGHT',
} as const;

type ThemeType = typeof ThemeType[keyof typeof ThemeType];

export const themeSlice = createSlice({
    name: 'theme',
    initialState,
    reducers: {
        setBackground: (state, action: PayloadAction<ThemeType>) => {
            state.background = getThemeUrl(action.payload);
            state.theme = action.payload == ThemeType.DARK ? 'dark' : 'light';
        },
    },
});

export const {setBackground} = themeSlice.actions;
// export default slice.reducer;